// extracted by mini-css-extract-plugin
export default {"container":"lQ94a","triangleBorder":"aP8Ee","defaultColor":"eH81j","triangleBackground":"JZTsE"};